import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Option} from '../../options/option-row/option';

@Component({
    selector: 'app-advance-emi-option-row',
    templateUrl: './advance-emi-option-row.component.html',
    styleUrls: ['./advance-emi-option-row.component.scss']
})
export class AdvanceEmiOptionRowComponent {
    @Input()
    option: Option;

    @Input()
    balanceAmount: number;

    @Input()
    advanceEmiCount: number;

    @Output()
    onApply: EventEmitter<Option> = new EventEmitter();

    async apply(option: Option): Promise<void> {
        this.onApply.emit(option);
    }
}
